import React, { useState, useEffect } from "react";
import "./AboutVenueDetails.css";
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import { MdOutlineMail } from "react-icons/md";
import axios from "axios";
import ClubReviewModal from "./ClubReviewModal";
import ReactStars from "react-stars";
import { API_BASE_URL } from "../../utils";

export default function AboutVenueDetails({ data }) {
  return (
    <div className="mt-3">
      <h2 className="venue-heading ">About</h2>
      <div className="venue-about-container row-gap-set">
        <div className="highlight-section">
          <h6>About The {data?.name}</h6>
          <p className="about-venue">
            {" "}
            {data?.about?.description ||
              `${data?.about?.venue_type} in ${data?.areaName}, ${data?.cityName} is a premium party destination, perfect for birthdays, weekend hangouts, and office get-togethers. It offers hassle-free table bookings, delicious food, live music, and excellent service. With a stylish setup and customized packages, every celebration feels truly special. Whether you’re planning a small gathering or a grand event, this venue provides a lively vibe and a stress-free experience. Celebrate unforgettable moments with your loved ones, friends, family, or colleagues in a vibrant, fun-filled atmosphere that turns every occasion into a lasting memory.`}
          </p>
        </div>
        <hr />

        <div className="highlight-section">
          <h6 className="mb-1">Highlights</h6>
          <div className=" row p-0 w-100 hilight">
            <div className=" col-md-6">
              <p>Capacity : Up to 500 guest</p>
              <p>Valet Parking Available</p>
              <p>In-house Catering & DJ</p>
            </div>
            <div className="col-md-6">
              <p>Dedicated Bridal Room</p>
              <p>Air Conditioned Banquet Halls</p>
            </div>
          </div>
        </div>
        <hr />
        <div className="highlight-section">
          <h6 className="mb-1">Venue Features</h6>
          <div className="row p-0 w-100 hilight">
            <div className="col-md-6">
              <p>Stage Setup</p>
              <p>Led Screens</p>
              <p>Lawn + Indoor Halls</p>
            </div>
            <div className="col-md-6">
              <p>Custom Decor</p>
              <p>Live counters</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
